'use client';
import { cx } from '@mage-ui/styled-system/css';
import { tableTd } from '@mage-ui/styled-system/recipes';

//TableCell
export const TableTd = ({ data, className, ...props }) => {
	const tdProps = {};
	if (data?.colspan) {
		tdProps.colSpan = data.colspan;
	}
	if (data?.rowspan) {
		tdProps.rowSpan = data.rowspan;
	}

	return (
		<td
			className={cx(tableTd(), className)}
			{...props}
			{...tdProps}
			dangerouslySetInnerHTML={{ __html: data?.title }}
		/>
	);
};
